import { getLabel } from './labels';
import { getPathDetails } from './environments';
import { log } from './log';

import en from './newTranslations/en.json';
import de from './newTranslations/de.json';
import es from './newTranslations/es.json';
import fr from './newTranslations/fr.json';
import it from './newTranslations/it.json';
import ja from './newTranslations/ja.json';
import ko from './newTranslations/ko.json';
import nl from './newTranslations/nl.json';
import ptBR from './newTranslations/pt-BR.json';
import sv from './newTranslations/sv.json';
import zhHans from './newTranslations/zh-Hans.json';
import zhHant from './newTranslations/zh-Hant.json';

const translationsMap = {
  en,
  de,
  es,
  fr,
  it,
  ja,
  ko,
  nl,
  'pt-BR': ptBR,
  sv,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};

/**
 * Enhanced label lookup with fallback to static JSON translations.
 *
 * 1. First attempts to resolve via the existing getLabel() from labels.js.
 * 2. If getLabel() returns the original text (no translation found),
 *    falls back to a static JSON translation map from newTranslations/
 *    based on the language extracted from the URL.
 * 3. If still not found, returns the original English text as-is.
 *
 * @param {string} text - The English source text to translate.
 * @returns {string} The localized text, or the original English text as fallback.
 */
export function getLabelV2(text) {
  // Step 1: Try existing getLabel() from labels.js
  const existing = getLabel(text);

  if (existing !== text) {
    return existing;
  }

  // Step 2: Extract lang from URL
  const { lang } = getPathDetails();

  // Step 3: Hash map lookup from static JSON translations
  const data = translationsMap[lang];

  if (data && data[text] !== undefined) {
    return data[text];
  }

  // Step 4: Final fallback — return original English text
  log(`Translation not found in labelV2 for "${text}" in language "${lang}"`);
  return text;
}
